import { MARKETS, LOCALES, GLOBAL, EN_GB } from '@clearscore/config.i18n';
import { getSessionCookie } from '@clearscore/helpers.cookies';
import { resolveProp } from '@clearscore/helpers.resolve-props';
import requestStatuses from '@clearscore/constants.request-statuses';

import {
    MARKET_SET_LOCALES,
    MARKET_SET_MARKETS,
    MARKET_SET_ACTIVE_LOCALE,
    MARKET_SET_ACTIVE_MARKET,
    MARKET_SET_GEO_MARKET,
    MARKET_CHECK,
    MARKET_CHECK_SUCCESS,
    MARKET_CHECK_ERROR,
    MARKET_FETCH_CONFIG,
    MARKET_FETCH_CONFIG_SUCCESS,
    MARKET_FETCH_STATIC_CONFIG,
    MARKET_FETCH_STATIC_CONFIG_SUCCESS,
} from '../types';

const getCurrentMarketDetails = () => {
    const sessionToken = getSessionCookie();
    const marketSessionToken = resolveProp('market', sessionToken);
    const localeSessionToken = resolveProp('locale', sessionToken);

    return {
        marketSessionToken,
        localeSessionToken,
    };
};

const getActiveMarket = () => {
    const { marketSessionToken } = getCurrentMarketDetails();
    return marketSessionToken || GLOBAL;
};

const getActiveLocale = () => {
    const { marketSessionToken, localeSessionToken } = getCurrentMarketDetails();

    if (localeSessionToken) return localeSessionToken;
    if (marketSessionToken) return `en-${marketSessionToken}`;
    return EN_GB;
};

const initialState = () => ({
    checkStatus: requestStatuses.INITIAL,
    fetchStatus: requestStatuses.INITIAL,
    activeMarket: getActiveMarket(),
    activeLocale: getActiveLocale(),
    markets: MARKETS,
    locales: LOCALES,
});

const domain = (state = initialState(), action) => {
    const { type, payload } = action;

    switch (type) {
        case MARKET_FETCH_CONFIG:
        case MARKET_FETCH_STATIC_CONFIG:
            return {
                ...state,
                fetchStatus: requestStatuses.PENDING,
            };
        case MARKET_FETCH_CONFIG_SUCCESS:
        case MARKET_FETCH_STATIC_CONFIG_SUCCESS:
            return {
                ...state,
                fetchStatus: requestStatuses.SUCCESS,
            };
        case MARKET_CHECK:
            return {
                ...state,
                checkStatus: requestStatuses.PENDING,
            };
        case MARKET_CHECK_SUCCESS:
            return {
                ...state,
                geoMarket: (payload.marketId || '').toLowerCase(),
                checkStatus: requestStatuses.SUCCESS,
            };
        case MARKET_CHECK_ERROR:
            return {
                ...state,
                checkStatus: requestStatuses.ERROR,
            };
        case MARKET_SET_ACTIVE_MARKET: {
            const { geoMarket, ...restState } = state;
            return {
                ...restState,
                activeMarket: (payload && payload.market) || initialState().activeMarket,
                activeLocale: (payload && `en-${payload.market}`) || initialState().activeLocale,
            };
        }
        case MARKET_SET_ACTIVE_LOCALE:
            return {
                ...state,
                activeLocale: payload || initialState().activeLocale,
            };
        case MARKET_SET_LOCALES:
            return {
                ...state,
                locales: payload || initialState().locales,
            };
        case MARKET_SET_MARKETS:
            return {
                ...state,
                markets: payload || initialState().markets,
            };
        case MARKET_SET_GEO_MARKET:
            return {
                ...state,
                geoMarket: payload,
            };
        default:
            return state;
    }
};

export default domain;
